// extracted by mini-css-extract-plugin
var _1 = "block___mcla5";
var _2 = "wrapper___NCj30";
export { _1 as "block", _2 as "wrapper" }
